
import MatrixInputItemCollapse from "./MatrixInputItemCollapse";

const MatrixInputNonDesktopInterface = props => {
  const {
    fieldName,
    items,
    options,
    isChecked,
    onChange,
    maximumSelectableOptions,
    singleOptionSelection
  } = props;

  return (
    <div className="matrix-input-non-desktop-interface">
      {items.map(item => (
        <MatrixInputItemCollapse
          key={item.id}
          item={item}
          fieldName={fieldName}
          options={options}
          isChecked={isChecked}
          onChange={onChange}
          maximumSelectableOptions={maximumSelectableOptions}
          singleOptionSelection={singleOptionSelection}
        />
      ))}
    </div>
  );
};

export default MatrixInputNonDesktopInterface;
